<template>
  <body>

    <b-navbar toggleable="md" type="dark" variant="dark" :class="'sticky-top p-0 shadow' + (isSiteAdmin ? ' is-site-admin' : '')">

      <b-navbar-brand to="/" class="d-inline-flex align-items-center py-1">
        <img src="/justice-story-offizielles-rundlogo.png" alt="Justice Story seal — Every Client Has a Story" width="58" height="58" style="width:58px;height:58px;object-fit:cover;border-radius:50%;flex-shrink:0;" />
        <span class="ml-2 d-flex flex-column justify-content-center text-light" style="font-family: 'Chivo', Arial, sans-serif; line-height: 1.15; white-space: nowrap;">
          <span style="font-size: clamp(18px, 2.5vw, 25px); font-weight: 700; letter-spacing: -.025em;">Justice Story</span>
          <span style="font-size: clamp(10px, 1.3vw, 13px); font-weight: 400; letter-spacing: .01em; margin-top: 3px;">Every Client Has a Story</span>
        </span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav class="px-3">
          <b-nav-item v-if="applicationUser && isClient">{{applicationUser.firstName}} {{applicationUser.lastName}}, Client of {{applicationUser.client.subscriptionUser.applicationUser.displayName}}</b-nav-item>
          <b-nav-item to="/" v-if="applicationUser && (isSubscriber || isSiteAdmin)">{{applicationUser.firstName}} {{applicationUser.lastName}}</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="isSubscriber" right to="/">My Clients</b-nav-item>
          <b-nav-item v-if="isSubscriber" right to="/subscriber/manageSubscription">My Subscription</b-nav-item>
          <!-- <b-nav-item-dropdown right>
            <template slot="button-content">
              Wireframes
            </template>
            <b-dropdown-item to="/wireframe/subscriberDashboard">Attorney/Subscriber: Dashboard</b-dropdown-item>
            <b-dropdown-item to="/wireframe/inviteClient">Attorney/Subscriber: Invite Client</b-dropdown-item>
            <b-dropdown-item to="/wireframe/subscriberClientOverview">Attorney/Subscriber: Client Overview</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientLanding">Client: Landing</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio1">Client: Bio 1</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio2">Client: Bio 2</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientBio3">Client: Bio 3</b-dropdown-item>
            <b-dropdown-item to="/wireframe/clientGad">Client: GAD Assessment</b-dropdown-item>
          </b-nav-item-dropdown> -->
          <b-nav-item right to="/page/client-help" v-if="isClient">Help</b-nav-item>
          <b-nav-item right to="/page/subscriber-help" v-if="isSubscriber">Help</b-nav-item>
          <!-- <b-nav-item right to="/testingNotes">Testing Notes</b-nav-item> -->
          <b-nav-item-dropdown right v-if="isSiteAdmin">
            <template slot="button-content">
              Debug
            </template>
            <b-dropdown-item href="/hangfire" target="_blank">Hangfire Dashboard</b-dropdown-item>
            <b-dropdown-item href="/swagger" target="_blank">Swagger UI</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template slot="button-content">
              {{$root.$data.authenticatedUser.username ? $root.$data.authenticatedUser.username : 'Not Logged In'}}
            </template>
            <b-dropdown-item to="/subscribe" v-if="!$root.$data.authenticatedUser.username">Sign Up</b-dropdown-item>
            <b-dropdown-item to="/changePassword" v-if="$root.$data.authenticatedUser.username && !isClient">Change Password</b-dropdown-item>
            <b-dropdown-item to="/verifyPhonenumber" v-if="$root.$data.authenticatedUser.username && !isClient">Enable Two Factor Authentication</b-dropdown-item>
            <b-dropdown-item to="/login" v-if="!$root.$data.authenticatedUser.username">Log In</b-dropdown-item>
            <b-dropdown-item to="/logout" v-if="$root.$data.authenticatedUser.username">Log Out</b-dropdown-item>
          </b-nav-item-dropdown>
          
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <b-alert v-if="updateExists" class="py-3 my-0" show dismissable variant="secondary">
      <span class="mr-3">An updated version of Justice Story is available.</span>
      <b-button @click="refreshApp" class="ml-3">Update Now</b-button>
    </b-alert>

    <div class="container-fluid">
      <div class="row">

        <nav v-if="isSiteAdmin" id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
          <div class="sidebar-sticky pt-3">

            <b-nav vertical>
              <b-nav-item to="/">Dashboard</b-nav-item>
            </b-nav>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="isSiteAdmin">
              <span>Admin</span>
            </h6>

            <b-nav vertical v-if="isSiteAdmin">
              <b-nav-item to="/applicationUser">Users</b-nav-item>
              <b-nav-item to="/subscription">Subscriptions</b-nav-item>
              <b-nav-item to="/client">Clients</b-nav-item>
              <b-nav-item to="/template">Templates</b-nav-item>
              <b-nav-item to="/contentBlock">Content</b-nav-item>
            </b-nav>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted" v-if="isSiteAdmin">
              <span>Debug</span>
            </h6>

            <b-nav vertical v-if="isSiteAdmin">
              <b-nav-item href="/hangfire" target="_blank">Hangfire</b-nav-item>
              <b-nav-item href="/swagger" target="_blank">Swagger</b-nav-item>
            </b-nav>

          </div>
        </nav>

        <main role="main" :class="(isSiteAdmin ? 'col-md-9 col-lg-10 is-site-admin ' : '') + 'ml-sm-auto px-md-4 w-100'">
          <!-- ml-sm-auto -->
          <router-view></router-view>
        </main>
      </div>
    </div>

    <footer class="footer">
      <div :class="'bg-secondary text-light ' + (!isSiteAdmin ? 'container text-center' : 'text-right pr-3')">
        <span class="footer-link">Copyright &copy; 2020-2024 Justice Story</span>
        &bull;
        <span class="footer-link"><b-link href="https://www.justicestory.com">Home</b-link></span>
        &bull;
        <span class="footer-link"><b-link to="/page/terms-and-conditions">Terms and Conditions</b-link></span>
        <span v-if="isSubscriber || isSiteAdmin">&bull;</span>
        <span class="footer-link"><b-link to="/page/contact-us">Contact Us</b-link></span>
      </div>
    </footer>

  </body>
</template>

<script>
import axios from "axios";
import AuthMixin from './components/Mixins/AuthMixin.vue'
import EventBus from './components/Common/EventBus.js'
import AppUpdateMixin from './components/Mixins/AppUpdate.vue'

export default {
  name: 'app',
  mixins: [AuthMixin, AppUpdateMixin],
  data() {
    return {
      applicationUser: null
    };
  },
  computed: {
    isSiteAdmin: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Site Admin');
    },
    isSubscriber: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Subscriber');
    },
    isClient: function () {
      return this.$root.$data.authenticatedUser && this.$root.$data.authenticatedUser.roles && this.$root.$data.authenticatedUser.roles.includes('Client');
    }
  },
  methods: {
    showToast: function (text, options) {
      this.$bvToast.toast(text, options);
    },
    loadUser: function () {
      if (!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.id) {
        this.applicationUser = null;
        return;
      }

      axios
        .get('/api/applicationUser/' + this.$root.$data.authenticatedUser.id + '?includes=Client,Client.SubscriptionUser,Client.SubscriptionUser.Subscription,Client.SubscriptionUser.ApplicationUser')
        .then(response => {
          this.applicationUser = response.data;
        })
        .catch(error => {
          console.log(error);
        });    

    }
  },
  mounted() {
    EventBus.$on('authenticated', authenticatedUser => {
      this.loadUser();
    })

    this.refreshAuthenticationData();



    // if ((!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.username) && localStorage.getItem('jwt')) {
    //   axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');

    //   this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
    //   this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
    //   this.$root.$data.authenticatedUser.roles = JSON.parse(localStorage.getItem('roles'));
    // }
  }
}
</script>
